/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { ValidationFailure as FluentValidationResultsValidationFailure } from '../models/FluentValidation/Results/validation-failure';
import { AnfrageDisplayModel as AceXFoundPortalCoreCaqModelsAnfrageDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/anfrage-display-model';
import { AnfrageListDisplayModel as AceXFoundPortalCoreCaqModelsAnfrageListDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model';
import { ContactDataDisplayModel as AceXFoundPortalCoreCaqModelsContactDataDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/contact-data-display-model';
import { DataprotectionNotificationDisplayModel as AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/dataprotection-notification-display-model';
import { DocumentDisplayModel as AceXFoundPortalCoreCaqModelsDocumentDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/document-display-model';
import { DocumenttypeDisplayModel as AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/documenttype-display-model';
import { FinanceDataDisplayModel as AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/finance-data-display-model';
import { FrageDisplayModel as AceXFoundPortalCoreCaqModelsFrageDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/frage-display-model';
import { MittelabrufDataDisplayModel as AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/mittelabruf-data-display-model';
import { PaymentFoerdersummenDisplayModel as AceXFoundPortalCoreCaqModelsPaymentFoerdersummenDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/payment-foerdersummen-display-model';
import { ProjectDataDisplayModel as AceXFoundPortalCoreCaqModelsProjectDataDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/project-data-display-model';
import { ProjektDisplayModel as AceXFoundPortalCoreCaqModelsProjektDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/projekt-display-model';
import { ProjektberichtWithAbschnitteDisplayModel as AceXFoundPortalCoreCaqModelsProjektberichtWithAbschnitteDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/projektbericht-with-abschnitte-display-model';
import { ProjektideeDisplayModel as AceXFoundPortalCoreCaqModelsProjektideeDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/projektidee-display-model';
import { RevokeDisplayModel as AceXFoundPortalCoreCaqModelsRevokeDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/revoke-display-model';
import { ScheduleDisplayModel as AceXFoundPortalCoreCaqModelsScheduleDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/schedule-display-model';
import { StipendiumDisplayModel as AceXFoundPortalCoreCaqModelsStipendiumDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/stipendium-display-model';
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';

@Injectable({
providedIn: 'root',
})

export class AnfrageService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiAnfrageProjektGet
   */
  static readonly ApiAnfrageProjektGetPath = '/api/Anfrage/Projekt';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageProjektGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageProjektGet$Response(params?: {
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageProjektGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageProjektGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageProjektGet(params?: {
  }): Observable<AceXFoundPortalCoreCaqModelsProjektDisplayModel> {

    return this.apiAnfrageProjektGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsProjektDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageProjektIdeeGet
   */
  static readonly ApiAnfrageProjektIdeeGetPath = '/api/Anfrage/ProjektIdee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageProjektIdeeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageProjektIdeeGet$Response(params?: {
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektideeDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageProjektIdeeGetPath, 'get');
    if (params) {
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektideeDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageProjektIdeeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageProjektIdeeGet(params?: {
  }): Observable<AceXFoundPortalCoreCaqModelsProjektideeDisplayModel> {

    return this.apiAnfrageProjektIdeeGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektideeDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsProjektideeDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageGet
   */
  static readonly ApiAnfrageGetPath = '/api/Anfrage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageGet$Response(params?: {
    'x-anfragescope'?: Array<AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt>;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsAnfrageListDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsAnfrageListDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageGet(params?: {
    'x-anfragescope'?: Array<AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt>;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsAnfrageListDisplayModel>> {

    return this.apiAnfrageGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsAnfrageListDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsAnfrageListDisplayModel>)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdGet
   */
  static readonly ApiAnfrageAnfrageIdGetPath = '/api/Anfrage/{anfrageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsAnfrageDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsAnfrageDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsAnfrageDisplayModel> {

    return this.apiAnfrageAnfrageIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsAnfrageDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsAnfrageDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdScopeDelete
   */
  static readonly ApiAnfrageAnfrageIdScopeDeletePath = '/api/Anfrage/{anfrageId}/{scope}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdScopeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdScopeDelete$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    scope: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdScopeDeletePath, 'delete');
    if (params) {
      rb.path('scope', params.scope, {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdScopeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdScopeDelete(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    scope: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdScopeDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageScopePost
   */
  static readonly ApiAnfrageScopePostPath = '/api/Anfrage/{scope}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageScopePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageScopePost$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    scope: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: string
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageScopePostPath, 'post');
    if (params) {
      rb.path('scope', params.scope, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageScopePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageScopePost(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    scope: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    body?: string
  }): Observable<string> {

    return this.apiAnfrageScopePost$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdAttachmentGet
   */
  static readonly ApiAnfrageAnfrageIdAttachmentGetPath = '/api/Anfrage/{anfrageId}/Attachment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdAttachmentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAttachmentGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    sectionId?: string;
    loadContent?: boolean;
    loadDocumentType?: boolean;
    projektberichtId?: string;
    paymentId?: string;
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdAttachmentGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('sectionId', params.sectionId, {});
      rb.query('loadContent', params.loadContent, {});
      rb.query('loadDocumentType', params.loadDocumentType, {});
      rb.query('projektberichtId', params.projektberichtId, {});
      rb.query('paymentId', params.paymentId, {});
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdAttachmentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAttachmentGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    sectionId?: string;
    loadContent?: boolean;
    loadDocumentType?: boolean;
    projektberichtId?: string;
    paymentId?: string;
    gutachtenId?: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    return this.apiAnfrageAnfrageIdAttachmentGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdAttachmentPatch
   */
  static readonly ApiAnfrageAnfrageIdAttachmentPatchPath = '/api/Anfrage/{anfrageId}/Attachment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdAttachmentPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdAttachmentPatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    projektberichtId?: string;
    gutachtenId?: string;
    paymentId?: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdAttachmentPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('projektberichtId', params.projektberichtId, {});
      rb.query('gutachtenId', params.gutachtenId, {});
      rb.query('paymentId', params.paymentId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdAttachmentPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdAttachmentPatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    projektberichtId?: string;
    gutachtenId?: string;
    paymentId?: string;
    body?: AceXFoundPortalCoreCaqModelsDocumentDisplayModel
  }): Observable<AceXFoundPortalCoreCaqModelsDocumentDisplayModel> {

    return this.apiAnfrageAnfrageIdAttachmentPatch$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsDocumentDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdDocumenttypesGet
   */
  static readonly ApiAnfrageAnfrageIdDocumenttypesGetPath = '/api/Anfrage/{anfrageId}/Documenttypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdDocumenttypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdDocumenttypesGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    sectionId?: string;
    byPhase?: boolean;
    berichtId?: string;
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdDocumenttypesGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('sectionId', params.sectionId, {});
      rb.query('byPhase', params.byPhase, {});
      rb.query('berichtId', params.berichtId, {});
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdDocumenttypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdDocumenttypesGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    sectionId?: string;
    byPhase?: boolean;
    berichtId?: string;
    gutachtenId?: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel>> {

    return this.apiAnfrageAnfrageIdDocumenttypesGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsDocumenttypeDisplayModel>)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdAttachmentDocumentIdGet
   */
  static readonly ApiAnfrageAnfrageIdAttachmentDocumentIdGetPath = '/api/Anfrage/{anfrageId}/Attachment/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdAttachmentDocumentIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAttachmentDocumentIdGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    documentId: string;
    loadContent?: boolean;
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdAttachmentDocumentIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.path('documentId', params.documentId, {});
      rb.query('loadContent', params.loadContent, {});
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdAttachmentDocumentIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAttachmentDocumentIdGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    documentId: string;
    loadContent?: boolean;
    gutachtenId?: string;
  }): Observable<AceXFoundPortalCoreCaqModelsDocumentDisplayModel> {

    return this.apiAnfrageAnfrageIdAttachmentDocumentIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsDocumentDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdAttachmentDocumentIdDelete
   */
  static readonly ApiAnfrageAnfrageIdAttachmentDocumentIdDeletePath = '/api/Anfrage/{anfrageId}/Attachment/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdAttachmentDocumentIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAttachmentDocumentIdDelete$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    documentId: string;
    projektberichtId?: string;
    paymentId?: string;
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdAttachmentDocumentIdDeletePath, 'delete');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.path('documentId', params.documentId, {});
      rb.query('projektberichtId', params.projektberichtId, {});
      rb.query('paymentId', params.paymentId, {});
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdAttachmentDocumentIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAttachmentDocumentIdDelete(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    documentId: string;
    projektberichtId?: string;
    paymentId?: string;
    gutachtenId?: string;
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdAttachmentDocumentIdDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdAttachmentVorlageDocumententypIdGet
   */
  static readonly ApiAnfrageAnfrageIdAttachmentVorlageDocumententypIdGetPath = '/api/Anfrage/{anfrageId}/AttachmentVorlage/{documententypId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdAttachmentVorlageDocumententypIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAttachmentVorlageDocumententypIdGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    documententypId: string;
    reportId?: string;
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdAttachmentVorlageDocumententypIdGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.path('documententypId', params.documententypId, {});
      rb.query('reportId', params.reportId, {});
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdAttachmentVorlageDocumententypIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAttachmentVorlageDocumententypIdGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    documententypId: string;
    reportId?: string;
    gutachtenId?: string;
  }): Observable<AceXFoundPortalCoreCaqModelsDocumentDisplayModel> {

    return this.apiAnfrageAnfrageIdAttachmentVorlageDocumententypIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsDocumentDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdSubmitPost
   */
  static readonly ApiAnfrageAnfrageIdSubmitPostPath = '/api/Anfrage/{anfrageId}/Submit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdSubmitPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdSubmitPost$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdSubmitPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdSubmitPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdSubmitPost(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsDataprotectionNotificationDisplayModel
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdSubmitPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdProjectDataGet
   */
  static readonly ApiAnfrageAnfrageIdProjectDataGetPath = '/api/Anfrage/{anfrageId}/ProjectData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdProjectDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdProjectDataGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjectDataDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdProjectDataGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjectDataDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdProjectDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdProjectDataGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsProjectDataDisplayModel> {

    return this.apiAnfrageAnfrageIdProjectDataGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjectDataDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsProjectDataDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdProjectDataPatch
   */
  static readonly ApiAnfrageAnfrageIdProjectDataPatchPath = '/api/Anfrage/{anfrageId}/ProjectData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdProjectDataPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdProjectDataPatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsProjectDataDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdProjectDataPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdProjectDataPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdProjectDataPatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsProjectDataDisplayModel
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdProjectDataPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdUpdatePaymentsPatch
   */
  static readonly ApiAnfrageAnfrageIdUpdatePaymentsPatchPath = '/api/Anfrage/{anfrageId}/UpdatePayments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdUpdatePaymentsPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdUpdatePaymentsPatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: Array<string>
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdUpdatePaymentsPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdUpdatePaymentsPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdUpdatePaymentsPatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: Array<string>
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdUpdatePaymentsPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdMittelabrufDataGet
   */
  static readonly ApiAnfrageAnfrageIdMittelabrufDataGetPath = '/api/Anfrage/{anfrageId}/MittelabrufData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdMittelabrufDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdMittelabrufDataGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdMittelabrufDataGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdMittelabrufDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdMittelabrufDataGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel> {

    return this.apiAnfrageAnfrageIdMittelabrufDataGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsMittelabrufDataDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdContactDataGet
   */
  static readonly ApiAnfrageAnfrageIdContactDataGetPath = '/api/Anfrage/{anfrageId}/ContactData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdContactDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdContactDataGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsContactDataDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdContactDataGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsContactDataDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdContactDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdContactDataGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsContactDataDisplayModel> {

    return this.apiAnfrageAnfrageIdContactDataGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsContactDataDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsContactDataDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdContactDataPatch
   */
  static readonly ApiAnfrageAnfrageIdContactDataPatchPath = '/api/Anfrage/{anfrageId}/ContactData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdContactDataPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdContactDataPatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsContactDataDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdContactDataPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdContactDataPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdContactDataPatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsContactDataDisplayModel
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdContactDataPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdFinanceDataGet
   */
  static readonly ApiAnfrageAnfrageIdFinanceDataGetPath = '/api/Anfrage/{anfrageId}/FinanceData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdFinanceDataGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdFinanceDataGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdFinanceDataGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdFinanceDataGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdFinanceDataGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel> {

    return this.apiAnfrageAnfrageIdFinanceDataGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdFinanceDataPatch
   */
  static readonly ApiAnfrageAnfrageIdFinanceDataPatchPath = '/api/Anfrage/{anfrageId}/FinanceData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdFinanceDataPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdFinanceDataPatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdFinanceDataPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdFinanceDataPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdFinanceDataPatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsFinanceDataDisplayModel
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdFinanceDataPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageGetFragenByEntityAndAreaGet
   */
  static readonly ApiAnfrageGetFragenByEntityAndAreaGetPath = '/api/Anfrage/GetFragenByEntityAndArea';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageGetFragenByEntityAndAreaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageGetFragenByEntityAndAreaGet$Response(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId?: string;
    abschnittId?: string;
    reportId?: string;
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageGetFragenByEntityAndAreaGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.query('anfrageId', params.anfrageId, {});
      rb.query('abschnittId', params.abschnittId, {});
      rb.query('reportId', params.reportId, {});
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageGetFragenByEntityAndAreaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageGetFragenByEntityAndAreaGet(params?: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId?: string;
    abschnittId?: string;
    reportId?: string;
    gutachtenId?: string;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>> {

    return this.apiAnfrageGetFragenByEntityAndAreaGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsFrageDisplayModel>)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdValidateGet
   */
  static readonly ApiAnfrageAnfrageIdValidateGetPath = '/api/Anfrage/{anfrageId}/Validate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdValidateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdValidateGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    reportId?: string;
    gutachtenId?: string;
  }): Observable<StrictHttpResponse<{
[key: string]: Array<FluentValidationResultsValidationFailure>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdValidateGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('reportId', params.reportId, {});
      rb.query('gutachtenId', params.gutachtenId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        [key: string]: Array<FluentValidationResultsValidationFailure>;
        }>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdValidateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdValidateGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    reportId?: string;
    gutachtenId?: string;
  }): Observable<{
[key: string]: Array<FluentValidationResultsValidationFailure>;
}> {

    return this.apiAnfrageAnfrageIdValidateGet$Response(params).pipe(
      map((r: StrictHttpResponse<{
[key: string]: Array<FluentValidationResultsValidationFailure>;
}>) => r.body as {
[key: string]: Array<FluentValidationResultsValidationFailure>;
})
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdGetAnfrageInfoGet
   */
  static readonly ApiAnfrageAnfrageIdGetAnfrageInfoGetPath = '/api/Anfrage/{anfrageId}/GetAnfrageInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdGetAnfrageInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdGetAnfrageInfoGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsAnfrageDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdGetAnfrageInfoGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsAnfrageDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdGetAnfrageInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdGetAnfrageInfoGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsAnfrageDisplayModel> {

    return this.apiAnfrageAnfrageIdGetAnfrageInfoGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsAnfrageDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsAnfrageDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdScheduleGet
   */
  static readonly ApiAnfrageAnfrageIdScheduleGetPath = '/api/Anfrage/{anfrageId}/Schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdScheduleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdScheduleGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    reportId?: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsScheduleDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdScheduleGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('reportId', params.reportId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsScheduleDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdScheduleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdScheduleGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    reportId?: string;
  }): Observable<AceXFoundPortalCoreCaqModelsScheduleDisplayModel> {

    return this.apiAnfrageAnfrageIdScheduleGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsScheduleDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsScheduleDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdSchedulePatch
   */
  static readonly ApiAnfrageAnfrageIdSchedulePatchPath = '/api/Anfrage/{anfrageId}/Schedule';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdSchedulePatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdSchedulePatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    reportId?: string;
    body?: AceXFoundPortalCoreCaqModelsScheduleDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdSchedulePatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('reportId', params.reportId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdSchedulePatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdSchedulePatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    reportId?: string;
    body?: AceXFoundPortalCoreCaqModelsScheduleDisplayModel
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdSchedulePatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdAntragsdatenblaetterGet
   */
  static readonly ApiAnfrageAnfrageIdAntragsdatenblaetterGetPath = '/api/Anfrage/{anfrageId}/Antragsdatenblaetter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdAntragsdatenblaetterGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAntragsdatenblaetterGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    loadContent?: boolean;
  }): Observable<StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdAntragsdatenblaetterGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('loadContent', params.loadContent, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdAntragsdatenblaetterGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdAntragsdatenblaetterGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    loadContent?: boolean;
  }): Observable<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>> {

    return this.apiAnfrageAnfrageIdAntragsdatenblaetterGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>>) => r.body as Array<AceXFoundPortalCoreCaqModelsDocumentDisplayModel>)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdRevokePost
   */
  static readonly ApiAnfrageAnfrageIdRevokePostPath = '/api/Anfrage/{anfrageId}/Revoke';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdRevokePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdRevokePost$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsRevokeDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdRevokePostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdRevokePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdRevokePost(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsRevokeDisplayModel
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdRevokePost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdBerichtGet
   */
  static readonly ApiAnfrageAnfrageIdBerichtGetPath = '/api/Anfrage/{anfrageId}/Bericht';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdBerichtGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdBerichtGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektberichtWithAbschnitteDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdBerichtGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektberichtWithAbschnitteDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdBerichtGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdBerichtGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsProjektberichtWithAbschnitteDisplayModel> {

    return this.apiAnfrageAnfrageIdBerichtGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsProjektberichtWithAbschnitteDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsProjektberichtWithAbschnitteDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdSubmitBerichtBerichtIdPost
   */
  static readonly ApiAnfrageAnfrageIdSubmitBerichtBerichtIdPostPath = '/api/Anfrage/{anfrageId}/SubmitBericht/{berichtId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdSubmitBerichtBerichtIdPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdSubmitBerichtBerichtIdPost$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    berichtId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdSubmitBerichtBerichtIdPostPath, 'post');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.path('berichtId', params.berichtId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdSubmitBerichtBerichtIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdSubmitBerichtBerichtIdPost(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    berichtId: string;
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdSubmitBerichtBerichtIdPost$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdFundsPaymentsGet
   */
  static readonly ApiAnfrageAnfrageIdFundsPaymentsGetPath = '/api/Anfrage/{anfrageId}/Funds/Payments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdFundsPaymentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdFundsPaymentsGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsPaymentFoerdersummenDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdFundsPaymentsGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsPaymentFoerdersummenDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdFundsPaymentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdFundsPaymentsGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsPaymentFoerdersummenDisplayModel> {

    return this.apiAnfrageAnfrageIdFundsPaymentsGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsPaymentFoerdersummenDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsPaymentFoerdersummenDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdFundsPaymentPatch
   */
  static readonly ApiAnfrageAnfrageIdFundsPaymentPatchPath = '/api/Anfrage/{anfrageId}/Funds/Payment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdFundsPaymentPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdFundsPaymentPatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    paymentId?: string;
    body?: number
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdFundsPaymentPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.query('paymentId', params.paymentId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdFundsPaymentPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdFundsPaymentPatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    paymentId?: string;
    body?: number
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdFundsPaymentPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdStipendiumGet
   */
  static readonly ApiAnfrageAnfrageIdStipendiumGetPath = '/api/Anfrage/{anfrageId}/Stipendium';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdStipendiumGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdStipendiumGet$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsStipendiumDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdStipendiumGetPath, 'get');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsStipendiumDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdStipendiumGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAnfrageAnfrageIdStipendiumGet(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
  }): Observable<AceXFoundPortalCoreCaqModelsStipendiumDisplayModel> {

    return this.apiAnfrageAnfrageIdStipendiumGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsStipendiumDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsStipendiumDisplayModel)
    );
  }

  /**
   * Path part for operation apiAnfrageAnfrageIdStipendiumPatch
   */
  static readonly ApiAnfrageAnfrageIdStipendiumPatchPath = '/api/Anfrage/{anfrageId}/Stipendium';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAnfrageAnfrageIdStipendiumPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdStipendiumPatch$Response(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsStipendiumDisplayModel
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AnfrageService.ApiAnfrageAnfrageIdStipendiumPatchPath, 'patch');
    if (params) {
      rb.header('x-anfragescope', params['x-anfragescope'], {});
      rb.path('anfrageId', params.anfrageId, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: '*/*',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiAnfrageAnfrageIdStipendiumPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAnfrageAnfrageIdStipendiumPatch(params: {

    /**
     * 805290000 &#x3D; Projekt (Projekt)
     * 
     * 805290001 &#x3D; Projektidee (Projektidee)
     */
    'x-anfragescope'?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
    anfrageId: string;
    body?: AceXFoundPortalCoreCaqModelsStipendiumDisplayModel
  }): Observable<void> {

    return this.apiAnfrageAnfrageIdStipendiumPatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}